//视频加载进度监听函数-------------------------------
/**
 * 监听视频缓冲进度是否超过指定比例
 * @param {HTMLVideoElement} video - 视频元素
 * @param {number} threshold - 比例阈值 (0~1)，例如 1/3
 * @param {Function} callback - 达标时执行的回调
 * @param {boolean} once - 是否只触发一次，默认 true
 */
function onBufferProgress(video, threshold, callback, once = true) {
  // 确保视频元数据已加载，duration 可用
  function check() {
    if (!video.duration || !isFinite(video.duration)) return false;
    if (video.buffered.length === 0) return false;

    const bufferedEnd = video.buffered.end(video.buffered.length - 1);
    return (bufferedEnd / video.duration) > threshold;
  }

  // 元数据加载完成后才开始监听
  function startListening() {
    // 立刻检查一次，因为可能已经缓冲够了（例如预加载）
    if (check()) {
      callback();
      if (once) return; // 只触发一次则不再继续
    }

    // 监听 progress 事件
    function onProgress() {
      if (check()) {
        callback();
        if (once) {
          video.removeEventListener('progress', onProgress);
        }
      }
    }

    video.addEventListener('progress', onProgress);
  }

  if (video.readyState >= 1) {
    // 元数据已经加载了
    startListening();
  } else {
    video.addEventListener('loadedmetadata', startListening, { once: true });
  }
}

// 应用实例------------------------
// const video = document.querySelector('video');

// // 监听进度首次超过 1/3，只触发一次
// onBufferProgress(video, 1 / 3, () => {
//   console.log('视频已加载超过 1/3，可以开始一些操作了');
// });

// // 如果想每次都触发（例如更新 UI），将 once 设为 false
// onBufferProgress(video, 1 / 3, () => {
//   console.log('当前缓冲进度仍然超过 1/3');
// }, false);

// 预加载图片------------------------------------
function preloadImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`Failed to load image: ${url}`));
    img.src = url;
  });
}

async function preloadImagesWithPromise(urls, onProgress) {
  let loaded = 0;
  const total = urls.length;

  // 每个图片加载后更新进度
  const loadPromises = urls.map(async (url) => {
    try {
      const img = await preloadImage(url);
      loaded++;
      onProgress && onProgress(loaded, total, url);
      return img;
    } catch (err) {
      loaded++;
      onProgress && onProgress(loaded, total, url, true);
      throw err; // 如果需要整体失败，可重新抛出
    }
  });

  try {
    const images = await Promise.all(loadPromises);
    return images; // 所有图片加载成功
  } catch (err) {
    console.error('预加载过程中有图片失败', err);
    // 可处理部分失败的情况
  }
}

// 使用示例
// const urls = ['1.jpg', '2.jpg', '3.jpg'];
// preloadImagesWithPromise(urls, (loaded, total, url, error) => {
//   console.log(`${loaded}/${total}`, error ? '❌' : '✅', url);
// }).then(images => {
//   console.log('全部完成', images);
// });

// ------------图片预加载简化版，不阻塞主进程--------------------------------------------------
const preloadedSet = new Set();
function preloadSilently(urls) {
  if (typeof urls === 'string') urls = [urls];
  urls.forEach(url => {
    if (preloadedSet.has(url)) {//去重处理，对于已加载过的，直接返回
      // console.log(`⏭️ 图片已预加载，跳过：${url}`)
      return;
    } 
    const img = new Image();
    img.src = url;
    preloadedSet.add(url);
  });
}

// 使用示例-------------

// // 1. 先预加载
// const preloadUrl = (['page4.jpg', 'page5.jpg']);
// preloadSilently(preloadUrl);

// // 2. 过了一段时间（比如点击按钮或 Swiper 滑动结束），直接把 URL 赋给真正的 img
// document.getElementById('main-image').src = preloadUrl[0];
// // 此时浏览器会从缓存中瞬间读取，肉眼几乎看不到加载过程


// 滚动加载----------------------------------------------------------
// 获取元素相对于文档顶部的真实距离
function getOffsetTop(element) {
  let top = 0;
  while (element) {
    top += element.offsetTop;
    element = element.offsetParent;
  }
  return top;
}

// 判断元素是否距离视口底部（或顶部）小于等于 distance 像素
function isNearViewport(element, distance = 200) {
  const rect = element.getBoundingClientRect();
  // 只要元素顶部或底部进入“视口扩大 distance 像素”的区域就算接近
  return rect.top - distance <= window.innerHeight && rect.bottom + distance >= 0;
}

// 节流函数（保证滚动事件每秒最多执行几次，提升性能）
function throttle(fn, delay = 200) {
  let timer = null;
  return function(...args) {
    if (timer) return;
    timer = setTimeout(() => {
      fn.apply(this, args);
      timer = null;
    }, delay);
  };
}
function getElement(selector) {
  // 优先当作 id 处理（因为 id 唯一，且 id 选择器更快）
  let el = document.getElementById(selector);
  if (el) return el;
  // 其次当作 class 处理
  const classEls = document.getElementsByClassName(selector);
  return classEls.length ? classEls[0] : null;
}

// 懒加载主逻辑
function lazyload(sectionSelector, targetSelector, src, offset = 200) {
  const section = getElement(sectionSelector);
  const target = getElement(targetSelector);
  if (!section || !target) return;
  
  // 判断区域是否接近视口
  if (isNearViewport(section, offset) && !target.src) {
    target.src = src;
  }
}
// 懒加载背景图
function lazyloadBGimg(sectionSelector, targetSelector, src, offset = 200) {
  const section = getElement(sectionSelector);
  const target = getElement(targetSelector);
  if (!section || !target) return;
  
  // 判断区域是否接近视口
  if (isNearViewport(section, offset) && !target.style.backgroundImage) {
     target.style.backgroundImage = `url(${src})`;
  }
}
// 使用示例：监听滚动（页面加载时绑定一次）
// const lazyHandler = throttle(() => {
//   lazyload('.section1', '.lazy-img1', 'https://example.com/1.jpg', 200);
//   lazyload('#section2', '#lazy-video', 'https://example.com/video.mp4', 250);
//   // 可以继续添加多个...
// }, 200);

// window.addEventListener('scroll', lazyHandler);
// // 立即执行一次，防止首屏未滚动时漏加载
// lazyHandler();


// ========== 核心：基于 Intersection Observer 的懒加载管理器,性能比 lazyload 监听滚动好很多 ==========++++++
function getElement(selector) {
  let el = document.getElementById(selector);
  if (el) return el;
  const classEls = document.getElementsByClassName(selector);
  return classEls.length ? classEls[0] : null;
}

function createLazyLoader(items = [], autoObserve = true, defaultOffset = 200) {
  let paused = false;   
  let observer = null;
  const elementMap = new WeakMap();          // key: section元素, value: { element, src, poster }
  const sectionSet = new Set();              // 存储所有 section 元素（用于迭代）

  // 加载单个媒体
  function loadMedia(target, src, poster) {
    if (!target) return;
    const tag = target.tagName;
    if (tag === 'IMG') {
      if (src && target.src !== src) {
        target.src = src;
        target.classList.add('loaded');
      }
    } else if (tag === 'VIDEO') {
      if (poster && target.poster !== poster) {
        target.poster = poster;
      }
      if (src && target.src !== src) {
        target.src = src;
        target.load();
        target.classList.add('loaded');
      }
    }
  }
  // Intersection Observer 回调
  function handleIntersect(entries) {
    if (paused) return;  
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const data = elementMap.get(entry.target);
        if (data) {
          // 支持 srcset
          const target = data.element;
          if (target.tagName === 'IMG' && data.srcset) {
            if (target.srcset !== data.srcset) {
              target.srcset = data.srcset;
              target.classList.add('loaded');
            }
          }
          loadMedia(data.element, data.src, data.poster);
          observer.unobserve(entry.target);
          sectionSet.delete(entry.target); // 从集合中移除（已加载）
        }
      }
    });
  }

  // 创建/重建 Observer，使用当前所有 section 中的最大 offset
  function buildObserver() {
    if (observer) observer.disconnect();
    // 收集所有 section 对应的 offset
    let maxOffset = defaultOffset;
    for (const section of sectionSet) {
      const data = elementMap.get(section);
      if (data && data.offset > maxOffset) {
        maxOffset = data.offset;
      }
    }
    observer = new IntersectionObserver(handleIntersect, {
      root: null,
      rootMargin: `0px 0px ${maxOffset}px 0px`,
      threshold: 0
    });
    // 观察所有 section
    for (const section of sectionSet) {
      observer.observe(section);
    }
  }

  // 添加单个配置
  function add(item) {
    const section = getElement(item.section);
    const target = getElement(item.target);
    if (!section || !target) {
      console.warn(`无效配置: section=${item.section}, target=${item.target}`);
      return;
    }
    // 如果已经存在，先移除旧的观察
    if (sectionSet.has(section)) {
      if (observer) observer.unobserve(section);
      sectionSet.delete(section);
    }
    // 存储数据
    elementMap.set(section, {
      element: target,
      src: item.src || null,
      poster: item.poster || null,
      srcset: item.srcset || null,   
      offset: item.offset || defaultOffset
    });
    sectionSet.add(section);
    // 如果 observer 已存在，重建（因为可能 offset 变化）
    if (observer) {
      buildObserver();
    }
  }

  // 批量添加
  function addItems(newItems) {
    newItems.forEach(item => add(item));
    if (!observer && sectionSet.size > 0) {
      buildObserver();
    }
  }

  // 启动观察（如果尚未启动）
  function start() {
    if (observer) return;
    if (sectionSet.size === 0) {
      console.warn('没有配置任何懒加载项');
      return;
    }
    buildObserver();
  }

  // 停止观察
  function stop() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  // 销毁（清理所有）
  function destroy() {
    stop();
    // 清除所有记录（但 WeakMap 无法清空，只能重置引用，但这里无法在闭包中重置，只能清空 Set）
    sectionSet.clear();
    // elementMap 中的条目会在 section 被垃圾回收时自动释放，无需手动清理
  }

  // 初始化
  if (items.length && autoObserve) {
    addItems(items);
    start();
  } else if (items.length && !autoObserve) {
    addItems(items);
  }

  function pause() {
    paused = true;
    if (observer) {
      observer.disconnect();   // 彻底断开，队列里的回调也失效
      observer = null;
    }
  }

  function resume() {
    if (!paused) return;
    paused = false;
    if (sectionSet.size > 0) buildObserver();
  }

  return { add, addItems, start, stop, destroy ,pause, resume };
}

// ========== 初始化 ==========
function initLazyLoad(items, defaultOffset = 200) {
  return createLazyLoader(items, true, defaultOffset);
}

// 使用实例
// const lazyItems = [
//   { section: 'section1', target: 'img1', src: 'https://example.com/photo.jpg', offset: 200 },
//   { section: 'section2', target: 'video1', src: 'https://example.com/video.mp4', poster: 'https://example.com/poster.jpg', offset: 250 } //如果需要传参视频封面的情况
// ];

// const loader = initLazyLoad(lazyItems);
// 动态添加新的项
// loader.add({ section: 'section3', target: 'img2', src: '...' });



/**
 * 检测图片加载状态（支持缓存）-------------------------------------------
 * @param {HTMLImageElement} imgElement - 目标img元素
 * @returns {Promise<boolean>} true=加载成功, false=加载失败
 */
function waitImageLoaded(imgElement) {
  return new Promise((resolve) => {
    // 如果 complete 为 true，说明图片已经加载完毕（无论成功或失败）
    if (imgElement.complete) {
      // 判断是否是有效图片（自然宽度 > 0）
      resolve(imgElement.naturalWidth > 0);
      return;
    }

    // 2. 如果 complete 为 false，绑定事件监听
    const onLoad = () => {
      resolve(true);
      cleanup();
    };
    const onError = () => {
      resolve(false);
      cleanup();
    };
    const cleanup = () => {
      imgElement.removeEventListener('load', onLoad);
      imgElement.removeEventListener('error', onError);
    };

    imgElement.addEventListener('load', onLoad);
    imgElement.addEventListener('error', onError);
  });
}

// 使用示例
// const img = document.querySelector('img');
// waitImageLoaded(img).then((success) => {
//   if (success) {
//     console.log('图片加载完成，可以移除骨架屏动画了');
//     img.classList.add('loaded'); // 配合CSS隐藏背景渐变
//   } else {
//     console.log('图片加载失败，显示破图占位符');
//   }
// });


/**
 * ------------------------------------------------------------
 * 精确获取屏幕物理等级 (基于水平物理像素)
 * 标准：1K(FHD) / 2K(QHD) / 4K(UHD) / 8K及以上
 * ------------------------------------------------------------
 */

// (1) 获取物理分辨率的底层方法
function getAccurateScreenInfo() {
  // 防御 SSR 及非浏览器环境
  if (typeof window === 'undefined' || !window.screen) {
    return { physicalWidth: 0, physicalHeight: 0, dpr: 1 };
  }

  // 关键点：必须使用 Math.round，因为部分浏览器（如安卓）DPR 可能为 2.625
  const dpr = window.devicePixelRatio || 1;
  const physicalWidth = Math.round(window.screen.width * dpr);
  const physicalHeight = Math.round(window.screen.height * dpr);

  return {
    physicalWidth,
    physicalHeight,
    logicalWidth: window.screen.width,
    logicalHeight: window.screen.height,
    dpr: dpr
  };
}

// (2) 核心判断函数（支持自定义阈值，适应不同行业标准）
function getScreenCategory(customThresholds) {
  // 定义权威阈值（基于消费级显示器常规标准）
  const defaultThresholds = {
    LOW: 1800,    // 低于此值：老旧低分屏（1366x768, 1600x900）
    FHD: 2300,    // 1920x1080 归属 FHD；2560x1440 归属 2K
    QHD: 3000,    // 2560x1440 归属 2K；3840x2160 归属 4K
    UHD: 6000     // 3840x2160 归属 4K；7680x4320 归属 8K
  };

  const { LOW, FHD, QHD, UHD } = { ...defaultThresholds, ...customThresholds };
  const info = getAccurateScreenInfo();
  const { physicalWidth, physicalHeight } = info;

  // 容错：若获取失败
  if (physicalWidth === 0) {
    return { ...info, category: 'undefuned', level: 0 };
  }

  // 区间判定（严格从大到小，防止超宽屏误判）
  let category = '其它';
  let level = 0; // 用于业务排序

  if (physicalWidth >= UHD) {
    category = '8K';
    level = 4;
  } else if (physicalWidth >= QHD && physicalWidth < UHD) {
    category = '4K';
    level = 3;
  } else if (physicalWidth >= FHD && physicalWidth < QHD) {
    category = '2K';
    level = 2;
  } else if (physicalWidth >= LOW && physicalWidth < FHD) {
    category = '1K ';
    level = 1;
  } else {
    category = 'other';
    level = 0;
  }

  return {
    ...info,
    category,
    level,          // 数值等级，方便 if (level > 2) 判断高清屏
    displayName: `${category} (${physicalWidth}×${physicalHeight})`
  };
}

//使用案例
// const screen = getScreenCategory();
  
// let imageUrl = '';
// // 根据等级选择最佳素材（节约流量并保证清晰度）
// switch (screen.category) {
//   case '8K':
//     imageUrl = 'https://cdn.example.com/bg-8k.jpg';
//     break;
//   case '4K':
//     imageUrl = 'https://cdn.example.com/bg-4k.jpg';
//     break;
//   case '2K':
//     imageUrl = 'https://cdn.example.com/bg-2k.jpg';
//     break;
//   default: // 1K 和 其它
//     imageUrl = 'https://cdn.example.com/bg-fhd.jpg';
//     break;
// }

// 倒计时方法组件--------------------
/**
 * UTC-6 倒计时组件（函数版）
 * @param {Object}   options
 * @param {string|Element} options.el          容器（选择器或 DOM 节点）
 * @param {string}   options.targetLocal       目标时间 "YYYY-MM-DD HH:mm:ss"
 * @param {string|Function} [options.template] DOM 模板字符串 或 (data) => string
 * @param {Function} [options.render]          完全接管渲染 (container, data, isFirst)
 * @param {Object}   [options.selectors]       自定义字段选择器（覆盖默认）
 * @param {Function} [options.onTick]          每次更新回调 (data)
 * @param {Function} [options.onEnd]           结束回调
 * @param {boolean}  [options.hideOnEnd=true]  结束后是否隐藏容器
 * @param {number}   [options.interval=1000]   刷新间隔(ms)
 * @param {boolean}  [options.padDays=true]    天数<10 是否补零
 * @param {number}   [options.timezone=-6]     目标时间所属时区
 * @returns {{ stop: Function, destroy: Function, getState: Function }}
 */
function startCountdown(options) {
  'use strict';

  const opts = Object.assign({
    el: null,
    targetLocal: '',
    template: '',
    render: null,
    selectors: null,
    onTick: null,
    onEnd: null,
    hideOnEnd: true,
    interval: 1000,
    padDays: true,
    timezone: -6,
    daysLabel: { singular: 'Day', plural: 'Days' }
  }, options || {});

  // ---------- 工具 ----------
  const padZero = n => String(n).padStart(2, '0');

  // "YYYY-MM-DD HH:mm:ss" 按指定时区解释，转成真实时间戳
  function toTimestampUTC(str, tzOffsetHours) {
    const [datePart, timePart = '00:00:00'] = String(str).trim().split(/\s+/);
    const [Y, M, D] = datePart.split('-').map(Number);
    const [h, m, s] = timePart.split(':').map(x => Number(x || 0));
    const asUTC = Date.UTC(Y, M - 1, D, h, m, s, 0);
    return asUTC - tzOffsetHours * 3600 * 1000;
  }

  // ---------- 容器 ----------
  const container = typeof opts.el === 'string'
    ? document.querySelector(opts.el)
    : opts.el;

  if (!container) {
    console.warn('[Countdown] 找不到容器元素:', opts.el);
    return { stop() {}, destroy() {}, getState() { return null; } };
  }

  // ---------- 默认选择器（用 data-cd 作为锚点）----------
  const DEFAULT_SELECTORS = {
    days:      '[data-cd="days"]',
    hours:     '[data-cd="hours"]',
    mins:      '[data-cd="mins"]',
    secs:      '[data-cd="secs"]',
    daysLabel: '[data-cd="daysLabel"]'
  };

  const selectors = Object.assign({}, DEFAULT_SELECTORS, opts.selectors || {});

  const targetTs = toTimestampUTC(opts.targetLocal, opts.timezone);

  let timer    = null;
  let built    = false;
  let ended    = false;
  let nodes    = {};
  let lastData = null;

  // ---------- 计算 ----------
  function resolveDaysLabel(cfg, days) {
    let singular = 'Day';
    let plural   = 'Days';

    if (Array.isArray(cfg)) {
      singular = cfg[0] ?? singular;
      plural   = cfg[1] ?? singular;
    } else if (cfg && typeof cfg === 'object') {
      singular = cfg.singular ?? singular;
      plural   = cfg.plural   ?? singular;
    } else if (typeof cfg === 'string') {
      // 只传一个字符串时，单复数都用它
      singular = plural = cfg;
    }

    return days > 1 ? plural : singular;
  }
  function compute() {
    const now   = Date.now();
    const total = targetTs - now;
    const diff  = Math.max(0, total);

    const days  = Math.floor(diff / 86400000);
    const hours = Math.floor((diff % 86400000) / 3600000);
    const mins  = Math.floor((diff % 3600000) / 60000);
    const secs  = Math.floor((diff % 60000) / 1000);

    return {
      days, hours, mins, secs,
      daysText:  opts.padDays && days < 10 ? '0' + days : String(days),
      hoursText: padZero(hours),
      minsText:  padZero(mins),
      secsText:  padZero(secs),
      daysLabel: resolveDaysLabel(opts.daysLabel, days),
      totalMs:   diff,
      finished:  total <= 0
    };
  }

  // ---------- 构建 DOM（只执行一次）----------
  function build(data) {
    if (typeof opts.render === 'function') {
      opts.render(container, data, true);
    } else {
      const tpl = typeof opts.template === 'function'
        ? opts.template(data)
        : opts.template;
      container.innerHTML = tpl || '';
    }
    // 缓存节点
    nodes = {};
    for (const key in selectors) {
      nodes[key] = container.querySelector(selectors[key]);
    }
  }

  // ---------- 更新数值 ----------
  function update(data) {
    if (typeof opts.render === 'function') {
      opts.render(container, data, false);
      return;
    }
    if (nodes.days)      nodes.days.textContent      = data.daysText;
    if (nodes.hours)     nodes.hours.textContent     = data.hoursText;
    if (nodes.mins)      nodes.mins.textContent      = data.minsText;
    if (nodes.secs)      nodes.secs.textContent      = data.secsText;
    if (nodes.daysLabel) nodes.daysLabel.textContent = data.daysLabel;
  }

  // ---------- 主循环 ----------
  function tick() {
    const data = compute();
    lastData = data;

    if (!built) {
      build(data);
      built = true;
    }
    update(data);

    if (typeof opts.onTick === 'function') opts.onTick(data);

    if (data.finished) {
      stop();
      if (!ended) {
        ended = true;
        if (typeof opts.onEnd === 'function') opts.onEnd();
        if (opts.hideOnEnd) container.style.display = 'none';
      }
    }
  }

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function destroy() {
    stop();
    container.innerHTML = '';
    built = false;
    ended = false;
    nodes = {};
    lastData = null;
  }

  // ---------- 启动 ----------
  tick(); // 立即渲染一次，避免白屏
  if (!ended) {
    timer = setInterval(tick, opts.interval);
  }

  return {
    stop,
    destroy,
    getState: () => lastData
  };
}

// 倒计时方法组件--------------------
/**
 * UTC-6 倒计时组件（函数版）
 * @param {Object}   options
 * @param {string|Element} options.el          容器（选择器或 DOM 节点）
 * @param {string}   options.targetLocal       目标时间 "YYYY-MM-DD HH:mm:ss"
 * @param {string|Function} [options.template] DOM 模板字符串 或 (data) => string
 * @param {Function} [options.render]          完全接管渲染 (container, data, isFirst)
 * @param {Object}   [options.selectors]       自定义字段选择器（覆盖默认）
 * @param {Function} [options.onTick]          每次更新回调 (data)
 * @param {Function} [options.onEnd]           结束回调
 * @param {boolean}  [options.hideOnEnd=true]  结束后是否隐藏容器
 * @param {number}   [options.interval=1000]   刷新间隔(ms)
 * @param {boolean}  [options.padDays=true]    天数<10 是否补零
 * @param {number}   [options.timezone=-6]     目标时间所属时区
 * @returns {{ stop: Function, destroy: Function, getState: Function }}
 */
function startCountdown(options) {
  'use strict';

  const opts = Object.assign({
    el: null,
    targetLocal: '',
    template: '',
    render: null,
    selectors: null,
    onTick: null,
    onEnd: null,
    hideOnEnd: true,
    interval: 1000,
    padDays: true,
    timezone: -6,
    daysLabel: { singular: 'Day', plural: 'Days' }
  }, options || {});

  // ---------- 工具 ----------
  const padZero = n => String(n).padStart(2, '0');

  // "YYYY-MM-DD HH:mm:ss" 按指定时区解释，转成真实时间戳
  function toTimestampUTC(str, tzOffsetHours) {
    const [datePart, timePart = '00:00:00'] = String(str).trim().split(/\s+/);
    const [Y, M, D] = datePart.split('-').map(Number);
    const [h, m, s] = timePart.split(':').map(x => Number(x || 0));
    const asUTC = Date.UTC(Y, M - 1, D, h, m, s, 0);
    return asUTC - tzOffsetHours * 3600 * 1000;
  }

  // ---------- 容器 ----------
  const container = typeof opts.el === 'string'
    ? document.querySelector(opts.el)
    : opts.el;

  if (!container) {
    console.warn('[Countdown] 找不到容器元素:', opts.el);
    return { stop() {}, destroy() {}, getState() { return null; } };
  }

  // ---------- 默认选择器（用 data-cd 作为锚点）----------
  const DEFAULT_SELECTORS = {
    days:      '[data-cd="days"]',
    hours:     '[data-cd="hours"]',
    mins:      '[data-cd="mins"]',
    secs:      '[data-cd="secs"]',
    daysLabel: '[data-cd="daysLabel"]'
  };

  const selectors = Object.assign({}, DEFAULT_SELECTORS, opts.selectors || {});

  const targetTs = toTimestampUTC(opts.targetLocal, opts.timezone);

  let timer    = null;
  let built    = false;
  let ended    = false;
  let nodes    = {};
  let lastData = null;

  // ---------- 计算 ----------
  function resolveDaysLabel(cfg, days) {
    let singular = 'Day';
    let plural   = 'Days';

    if (Array.isArray(cfg)) {
      singular = cfg[0] ?? singular;
      plural   = cfg[1] ?? singular;
    } else if (cfg && typeof cfg === 'object') {
      singular = cfg.singular ?? singular;
      plural   = cfg.plural   ?? singular;
    } else if (typeof cfg === 'string') {
      // 只传一个字符串时，单复数都用它
      singular = plural = cfg;
    }

    return days > 1 ? plural : singular;
  }
  function compute() {
    const now   = Date.now();
    const total = targetTs - now;
    const diff  = Math.max(0, total);

    const days  = Math.floor(diff / 86400000);
    const hours = Math.floor((diff % 86400000) / 3600000);
    const mins  = Math.floor((diff % 3600000) / 60000);
    const secs  = Math.floor((diff % 60000) / 1000);

    return {
      days, hours, mins, secs,
      daysText:  opts.padDays && days < 10 ? '0' + days : String(days),
      hoursText: padZero(hours),
      minsText:  padZero(mins),
      secsText:  padZero(secs),
      daysLabel: resolveDaysLabel(opts.daysLabel, days),
      totalMs:   diff,
      finished:  total <= 0
    };
  }

  // ---------- 构建 DOM（只执行一次）----------
  function build(data) {
    if (typeof opts.render === 'function') {
      opts.render(container, data, true);
    } else {
      const tpl = typeof opts.template === 'function'
        ? opts.template(data)
        : opts.template;
      container.innerHTML = tpl || '';
    }
    // 缓存节点
    nodes = {};
    for (const key in selectors) {
      nodes[key] = container.querySelector(selectors[key]);
    }
  }

  // ---------- 更新数值 ----------
  function update(data) {
    if (typeof opts.render === 'function') {
      opts.render(container, data, false);
      return;
    }
    if (nodes.days)      nodes.days.textContent      = data.daysText;
    if (nodes.hours)     nodes.hours.textContent     = data.hoursText;
    if (nodes.mins)      nodes.mins.textContent      = data.minsText;
    if (nodes.secs)      nodes.secs.textContent      = data.secsText;
    if (nodes.daysLabel) nodes.daysLabel.textContent = data.daysLabel;
  }

  // ---------- 主循环 ----------
  function tick() {
    const data = compute();
    lastData = data;

    if (!built) {
      build(data);
      built = true;
    }
    update(data);

    if (typeof opts.onTick === 'function') opts.onTick(data);

    if (data.finished) {
      stop();
      if (!ended) {
        ended = true;
        if (typeof opts.onEnd === 'function') opts.onEnd();
        if (opts.hideOnEnd) container.style.display = 'none';
      }
    }
  }

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function destroy() {
    stop();
    container.innerHTML = '';
    built = false;
    ended = false;
    nodes = {};
    lastData = null;
  }

  // ---------- 启动 ----------
  tick(); // 立即渲染一次，避免白屏
  if (!ended) {
    timer = setInterval(tick, opts.interval);
  }

  return {
    stop,
    destroy,
    getState: () => lastData
  };
}

//使用实例-----------------
      // <div class="count_down_banner">
      //     <div class="count_down_til">SALE ENDS <strong>OCTOBER 18</strong></div>
      //     <div id="cus-utc6-countdown"></div>
      // </div>

    // startCountdown({
    //     el: '#cus-utc6-countdown',
    //     targetLocal: '2026-10-18 23:59:59',
    //     daysLabel: { singular: 'DAY', plural: 'DAYS' },
    //     template: `
    //         <div class="time-section">
    //             <div class="timeBox">
    //                 <div class="dayTime">
    //                     <div class="time_gap">
    //                         <span class="point left"></span>
    //                         <span class="tiemItem" data-cd="days"></span>
    //                         <span class="point right"></span>
    //                     </div>
    //                     <div class="time_unit" data-cd="daysLabel"></div>
    //                 </div>
    //                 <div class="dayTime">
    //                     <div class="time_gap">
    //                         <span class="point left"></span>
    //                         <span class="tiemItem" data-cd="hours"></span>
    //                         <span class="point right"></span>
    //                     </div>
    //                     <div class="time_unit">HOURS</div>
    //                 </div>
    //                 <div class="dayTime">
    //                     <div class="time_gap">
    //                         <span class="point left"></span>
    //                         <span class="tiemItem" data-cd="mins"></span>
    //                         <span class="point right"></span>
    //                     </div>
    //                     <div class="time_unit">MINS</div>
    //                 </div>
    //                 <div class="dayTime">
    //                     <div class="time_gap">
    //                         <span class="point left"></span>
    //                         <span class="tiemItem" data-cd="secs"></span>
    //                         <span class="point right"></span>
    //                     </div>
    //                     <div class="time_unit">SECS</div>
    //                 </div>
    //             </div>
    //         </div>
    //     `,
    //     onEnd: () => console.log('Countdown finished')
    // });

/*
 * 视频轮播：先加载 Swiper、custom_tool.js，播放器设置 externalControl: true。
 * 接入：initVideoCarousel({ root, items, ...options })，items 顺序须与 slide 一致。
 * 每项必填：section（懒加载区域 ID/类名）、target（唯一 video ID）、src（视频地址）。
 * 每项可选：poster（封面）、offset（初始视频加载距离，默认 300px）、
 *           posterOffset（封面加载距离，默认 400px）。
 * 扩展：selectors 更换选择器；swiperOptions 配置显示数量、间距和断点。
 * 返回：carousel（Swiper 实例）、destroy()（释放资源，之后可重新初始化）。
 *
 * 调度：Observer 检查封面与播放可见性；不支持时才监听滚动兜底。
 * 媒体事件、轮播切换及前后台切换同步播放；尺寸变化统一更新布局。
 */
// 同一根节点复用实例。
const videoCarouselInstances = new WeakMap();

// root 可传 DOM 节点或选择器，其余参数见默认值。
function initVideoCarousel(options = {}) {
  const {
    items = [], // 视频配置，顺序与 slide 一致。
    initialSlide = 1, // 初始项索引，从 0 开始。
    loop = true, // 循环轮播；单项时关闭，数量仍须满足 Swiper 要求。
    posterNeighbors = 1, // 左右各预加载几项封面，0 表示仅当前项。
    playbackThreshold = 0.2, // 舞台可见比例达到此值时播放，范围 (0, 1]。
    bufferThreshold = 1 / 3, // 当前视频缓冲达到此比例后，预加载左右相邻视频。
    swiperOptions = {}, // 扩展间距、断点等；loop、virtual 和导航元素由内部管理。
  } = options;
  const root =
    typeof options.root === "string"
      ? document.querySelector(options.root)
      : options.root;
  if (!root) throw new Error("Video carousel root not found");
  if (videoCarouselInstances.has(root)) return videoCarouselInstances.get(root);
  // 选择器均在 root 内查找，可通过 selectors 覆盖。
  const selectors = {
    stage: ".tnc-vc-stage",
    swiper: ".tnc-vc-swiper",
    prev: ".tnc-vc-prev",
    next: ".tnc-vc-next",
    ...options.selectors,
  };
  const stage = root.querySelector(selectors.stage);
  const swiperElement = root.querySelector(selectors.swiper);
  // 在当前组件内按 ID 原值匹配，避免特殊字符的选择器转义。
  const findById = (id) =>
    Array.from(root.querySelectorAll("[id]")).find(
      (element) => element.id === id,
    );
  // 与 items 保持相同索引，供切换、加载和播放共用。
  const players = items.map((item) => findById(item.target));
  // 初始化前校验依赖和节点，避免创建不完整的实例。
  if (
    typeof Swiper === "undefined" ||
    typeof initLazyLoad !== "function" ||
    typeof onBufferProgress !== "function" ||
    !items.length ||
    !stage ||
    !swiperElement ||
    players.some((video) => !video || video.tagName !== "VIDEO")
  ) {
    throw new Error(
      "Video carousel requires Swiper, custom_tool.js, stage, swiper and valid video items",
    );
  }
  // 校验行为参数；初始索引在创建 Swiper 时限制到有效范围。
  if (
    typeof loop !== "boolean" ||
    !Number.isInteger(initialSlide) ||
    !Number.isInteger(posterNeighbors) ||
    posterNeighbors < 0 ||
    !(playbackThreshold > 0 && playbackThreshold <= 1) ||
    !(bufferThreshold >= 0 && bufferThreshold <= 1)
  ) {
    throw new Error("Invalid video carousel options");
  }

  // inView 表示达到播放可见比例；destroyed 阻止卸载后的操作。
  let inView = false,
    destroyed = false;
  // 封面：按距离加载当前项和邻居，并缓存请求。
  const posterNeighborCount = posterNeighbors;
  // 记录已请求封面；不代表加载成功，也不自动重试。
  const posterRequests = new Map();
  // 当前项及邻居是否有未请求封面；切换或扩展动态 items 时需重算。
  let nearbyPostersPending = true;
  // 各项使用自己的 posterOffset；当前封面优先加载。
  function loadPoster(index, priority, viewportDistance) {
    const video = players[index];
    const item = items[index];
    if (
      destroyed ||
      !video ||
      !item.poster
    )
      return;
    const existing = posterRequests.get(index);
    if (existing) {
      if (priority === "high" && existing.fetchPriority !== "high")
        existing.fetchPriority = "high";
      return;
    }
    if (viewportDistance > (item.posterOffset ?? 400)) return;
    const image = new Image();
    image.fetchPriority = priority;
    posterRequests.set(index, image);
    image.src = item.poster;
    video.poster = item.poster;
  }
  // 舞台与视口相交时距离为 0，否则取各方向超出距离的最大值。
  function getViewportDistance(rect) {
    return Math.max(
      0,
      -rect.bottom,
      -rect.right,
      rect.top - document.documentElement.clientHeight,
      rect.left - document.documentElement.clientWidth,
    );
  }
  // 检查当前及相邻封面；复用传入的 rect，仅在有待请求封面时读取布局。
  function loadNearbyPosters(rect) {
    if (destroyed) return;
    const index = getActiveIndex();
    // 循环模式下邻居可能重合，去重后只检查一次。
    const indices = new Set([index]);
    for (let distance = 1; distance <= posterNeighborCount; distance++) {
      indices.add(getNeighborIndex(-distance));
      indices.add(getNeighborIndex(distance));
    }
    // 无封面或越界项不算待请求；请求前后均用此条件刷新状态。
    const hasPendingPoster = () =>
      [...indices].some((target) => items[target]?.poster && !posterRequests.has(target));
    nearbyPostersPending = hasPendingPoster();
    // 切换时提升已有封面的优先级；全部已请求后不再读取布局。
    const currentPoster = posterRequests.get(index);
    if (currentPoster && currentPoster.fetchPriority !== "high")
      currentPoster.fetchPriority = "high";
    if (!nearbyPostersPending) return;
    rect = rect ?? stage.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    const viewportDistance = getViewportDistance(rect);
    indices.forEach((target) =>
      loadPoster(target, target === index ? "high" : "low", viewportDistance),
    );
    nearbyPostersPending = hasPendingPoster();
  }
  // 视频：记录缓冲达标项，按需设置地址。
  const bufferedReady = new Set();
  // 忽略越界索引；已有 src 时不重复加载。
  function load(index) {
    const video = players[index];
    if (!video || video.hasAttribute("src")) return;
    video.preload = "auto";
    video.src = items[index].src;
    video.load();
  }
  // 单项禁用循环；后续邻居索引与 Swiper 使用同一设置。
  const loopEnabled = loop && players.length > 1;
  // 用户选项覆盖默认样式；后置配置保留组件对布局、循环和导航的控制。
  const carousel = new Swiper(swiperElement, {
    noSwipingSelector: ".custom_progress_box",
    slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: { 768: { spaceBetween: 30 } },
    ...swiperOptions,
    // 尺寸变化统一调用 update()，避免自动 resize 重排当前项。
    resizeObserver: false,
    updateOnWindowResize: false,
    initialSlide: Math.max(0, Math.min(initialSlide, players.length - 1)), // 将初始索引限制在有效范围内。
    loop: loopEnabled,
    virtual: { enabled: false },
    navigation: {
      prevEl: root.querySelector(selectors.prev),
      nextEl: root.querySelector(selectors.next),
    },
  });
  // 循环会重排 slide；用 realIndex 对应原始 items。
  function getActiveIndex() {
    const index = carousel.realIndex ?? carousel.activeIndex;
    return Number.isInteger(index) ? index : 0;
  }
  // offset 为相对当前项的偏移；非循环模式保留越界值，由加载函数忽略。
  function getNeighborIndex(offset) {
    const count = players.length;
    const index = getActiveIndex() + offset;
    return loopEnabled ? (index + count) % count : index;
  }
  // 只播放当前项；轮播离开视口或页面切到后台时暂停全部视频。
  function syncPlayback() {
    if (destroyed) return;
    const activeIndex = getActiveIndex();
    players.forEach((video, index) => {
      if (index !== activeIndex || !inView || document.hidden) {
        if (!video.paused) video.pause();
        return;
      }
      // 此处不加载当前视频，等待懒加载、切换或相邻预加载设置地址。
      if (!video.hasAttribute("src")) return;
      if (video.paused) {
        const pending = video.play();
        if (pending)
          pending.catch((error) => {
            // 离开视口引起的中断是正常情况；保留其他失败原因便于排查。
            if (
              !destroyed &&
              inView &&
              !document.hidden &&
              index === getActiveIndex()
            ) {
              // 暂停与恢复可能交错；仍需播放时在下一帧重试。
              if (error.name === "AbortError") {
                scheduleVisibilityCheck();
                return;
              }
              console.warn("[TNC video] 播放失败:", video.id, error);
            }
          });
      }
    });
    preloadNeighbors();
  }
  // 当前项缓冲达标，预加载左右相邻视频。
  function preloadNeighbors() {
    const index = getActiveIndex();
    if (destroyed || document.hidden || !bufferedReady.has(index))
      return;
    load(getNeighborIndex(-1));
    load(getNeighborIndex(1));
  }
  // 资源就绪或暂停后重新同步播放；缓冲达标后预加载邻居。
  // 扩展手动暂停时，需在 syncPlayback() 中判断用户意愿，避免自动恢复。
  const stopBufferListeners = players.map((video, index) => {
    video.addEventListener("canplay", syncPlayback);
    video.addEventListener("pause", scheduleVisibilityCheck);
    return onBufferProgress(video, bufferThreshold, () => {
      if (destroyed) return;
      bufferedReady.add(index);
      if (index === getActiveIndex()) preloadNeighbors();
    });
  });
  // 仅在实际索引变化时加载，忽略 loop 修正等重复事件。
  let lastActiveIndex = getActiveIndex();
  carousel.on("slideChange", () => {
    const index = getActiveIndex();
    if (destroyed || !carousel.initialized || index === lastActiveIndex) return;
    lastActiveIndex = index;
    // 切换不一定触发 Observer，主动刷新封面并加载目标视频。
    loadNearbyPosters();
    load(index);
    syncPlayback();
  });

  const initialIndex = getActiveIndex();
  players[initialIndex].preload = "auto";
  // 初始视频按 offset 懒加载；其余视频由缓冲达标或切换触发。
  const supportsObserver = typeof window.IntersectionObserver === "function";
  // 公共工具只加载初始视频，封面由上方逻辑独立管理。
  const initialItem = items[initialIndex];
  const lazyLoadMedia = supportsObserver
    ? initLazyLoad(
        [{ ...initialItem, poster: null }],
        initialItem.offset ?? 300,
      )
    : null;
  const posterObservers = []; // 按预加载距离保存，销毁时统一断开。
  let playObserver = null; // 播放可见性的唯一来源（支持 Observer 时）。
  let visibilityFrame = null; // 待执行检查帧的 ID，用于合并请求和取消。
  let layoutObserver = null; // 监听轮播容器尺寸变化。
  let layoutNeedsUpdate = false; // 下一次检查是否需要更新 Swiper 布局。
  // 统一更新布局、封面和播放；支持 Observer 时沿用其 inView。
  // 无 Observer 时按视口矩形估算可见性，不考虑祖先裁剪。
  function checkStageVisibility() {
    visibilityFrame = null;
    if (destroyed) return;
    if (layoutNeedsUpdate) {
      layoutNeedsUpdate = false;
      carousel.update();
    }
    const rect =
      !supportsObserver || nearbyPostersPending
        ? stage.getBoundingClientRect()
        : null;
    if (nearbyPostersPending) loadNearbyPosters(rect);
    if (!supportsObserver) {
      // 无 Observer 时补上初始视频的距离懒加载。
      const item = items[initialIndex];
      if (item && getViewportDistance(rect) <= (item.offset ?? 300)) {
        load(initialIndex);
      }
      // 相交面积占舞台总面积的比例达到阈值才允许播放。
      const viewportWidth = document.documentElement.clientWidth;
      const viewportHeight = document.documentElement.clientHeight;
      const visibleWidth = Math.max(
        0,
        Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0),
      );
      const visibleHeight = Math.max(
        0,
        Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0),
      );
      const area = rect.width * rect.height;
      inView =
        area > 0 && (visibleWidth * visibleHeight) / area >= playbackThreshold;
    }
    syncPlayback();
  }
  // 将重复检查合并到下一帧；涉及布局变化时调用 scheduleLayoutUpdate()。
  function scheduleVisibilityCheck() {
    if (visibilityFrame !== null || destroyed) return;
    visibilityFrame = requestAnimationFrame(checkStageVisibility);
  }
  // 滚动兜底；后台跳过，回到前台由 visibilitychange 同步。
  function onScroll() {
    if (destroyed || document.hidden) return;
    scheduleVisibilityCheck();
  }
  // 容器或窗口尺寸变化后，统一更新 Swiper 布局。
  function scheduleLayoutUpdate() {
    if (destroyed) return;
    layoutNeedsUpdate = true;
    scheduleVisibilityCheck();
  }
  // 容器尺寸也可能随父布局变化，不只随窗口缩放变化。
  if (typeof window.ResizeObserver === "function") {
    layoutObserver = new window.ResizeObserver(scheduleLayoutUpdate);
    layoutObserver.observe(swiperElement);
  }
  // 封面按 posterOffset 预加载，播放按 playbackThreshold 判断可见性。
  if (supportsObserver) {
    // 相同距离共用 Observer；自定义 root 时需同步调整 getViewportDistance()。
    const posterObserverMargins = new Set(
      items.map((item) => Math.max(0, item.posterOffset ?? 400)),
    );
    posterObserverMargins.forEach((margin) => {
      const observer = new IntersectionObserver(
        () => loadNearbyPosters(),
        { rootMargin: `${margin}px` },
      );
      observer.observe(stage);
      posterObservers.push(observer);
    });

    // 支持 Observer 时仅由此更新 inView，保留祖先裁剪结果。
    playObserver = new IntersectionObserver(
      (entries) => {
        if (destroyed || !entries.length) return;
        // 同一目标可能批量上报进出记录，必须使用最新状态。
        const entry = entries[entries.length - 1];
        inView =
          entry.isIntersecting &&
          entry.intersectionRatio >= playbackThreshold;
        syncPlayback();
      },
      { threshold: [0, playbackThreshold] },
    );
    playObserver.observe(stage);
  }
  // 仅无 Observer 时监听滚动；capture 覆盖嵌套容器，解绑时保持一致。
  if (!supportsObserver) {
    window.addEventListener("scroll", onScroll, { passive: true, capture: true });
  }
  window.addEventListener("resize", scheduleLayoutUpdate, { passive: true });
  // 页面恢复显示或资源加载完成后，重新检查封面及播放状态。
  window.addEventListener("pageshow", scheduleVisibilityCheck);
  window.addEventListener("load", scheduleVisibilityCheck);
  checkStageVisibility(); // 首次更新；支持 Observer 时等待其确认可见性。
  // 页面前后台切换时同步播放状态。
  document.addEventListener("visibilitychange", checkStageVisibility);
  // 手动销毁或区块卸载时释放资源；新增监听 / Observer 需在此配对清理。
  // 异步回调检查 destroyed，避免卸载后操作。
  function destroy() {
    if (destroyed) return;
    destroyed = true;
    if (lazyLoadMedia) lazyLoadMedia.destroy();
    posterObservers.forEach((observer) => observer.disconnect());
    if (playObserver) playObserver.disconnect();
    if (layoutObserver) layoutObserver.disconnect();
    posterRequests.clear();
    if (!supportsObserver) {
      window.removeEventListener("scroll", onScroll, true);
    }
    window.removeEventListener("resize", scheduleLayoutUpdate);
    window.removeEventListener("pageshow", scheduleVisibilityCheck);
    window.removeEventListener("load", scheduleVisibilityCheck);
    if (visibilityFrame !== null) cancelAnimationFrame(visibilityFrame);
    document.removeEventListener("visibilitychange", checkStageVisibility);
    document.removeEventListener("shopify:section:unload", onSectionUnload);
    players.forEach((video, index) => {
      stopBufferListeners[index]();
      video.pause();
      video.removeEventListener("canplay", syncPlayback);
      video.removeEventListener("pause", scheduleVisibilityCheck);
      // 清空地址并重置媒体加载，释放当前视频资源。
      video.removeAttribute("src");
      video.load();
    });
    carousel.destroy(true, true);
    videoCarouselInstances.delete(root);
  }
  // 只销毁卸载区块内的实例，避免影响页面上的其他轮播。
  function onSectionUnload(event) {
    if (event.target.contains(root)) destroy();
  }
  document.addEventListener("shopify:section:unload", onSectionUnload);
  // 缓存公开接口；同一 root 重复初始化时复用，销毁后可重新创建。
  const instance = { carousel, destroy };
  videoCarouselInstances.set(root, instance);
  return instance;
}